import React from "react";

const servicesData = [
  {
    title: 'Création d’identité numérique et physique',
    description:
      'Chaque éleveur reçoit un profil numérique sécurisé et une carte éleveur, liés à son cheptel, ses informations personnelles et sanitaires.'
  },
  {
    title: 'Fabrication et distribution de boucles électroniques',
    description:
      'Nous produisons des boucles uniques, infalsifiables et adaptées aux normes locales pour une identification fiable de chaque animal.'
  },
  {
    title: 'Enrôlement terrain des éleveurs et du bétail',
    description:
      'Nos agents sillonnent les zones rurales pour identifier chaque éleveur et poser une boucle à chaque animal.'
  },
  {
    title: 'Carnet sanitaire numérique',
    description:
      'Chaque animal a son propre carnet de santé en ligne, mis à jour par les vétérinaires : vaccins, maladies, traitements.'
  },
  {
    title: 'Plateforme interconnectée',
    description:
      'Une application web/mobile relie éleveurs, force de l’ordre, vétérinaires et autorités pour un suivi centralisé du bétail.'
  },
  {
    title: 'Suivi en temps réel et tableaux de bord décisionnels',
    description:
      'Les autorités disposent de tableaux de bord dynamiques alimentés en temps réel pour suivre la santé du cheptel, les mouvements, et détecter les zones à risque. Une intelligence artificielle intégrée assiste dans l’élaboration de politiques publiques ciblées et efficaces.'
  }
];

const ServicesPage = () => {
  return (
    <div
      style={{
        paddingTop: '100px',
        paddingBottom: '60px',
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#f4f7f9'
      }}
    >
      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 20px' }}>
        <p
          style={{
            textAlign: 'center',
            fontSize: '1.1rem',
            color: '#555',
            marginBottom: '40px'
          }}
        >
          Découvrez les services que nous proposons, ainsi que les détails de chaque service.
        </p>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '30px'
          }}
        >
          {servicesData.map((service, index) => (
            <div
              key={index}
              style={{
                backgroundColor: 'white',
                padding: '25px',
                borderRadius: '10px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s ease-in-out',
              }}
              onMouseEnter={e => (e.currentTarget.style.transform = 'translateY(-5px)')}
              onMouseLeave={e => (e.currentTarget.style.transform = 'translateY(0)')}
            >
              <h3
                style={{
                  color: '#1a73e8',
                  marginBottom: '10px',
                  textAlign: 'center',
                  fontSize: '1.2rem'
                }}
              >
                {service.title}
              </h3>
              <p
                style={{
                  color: '#555',
                  textAlign: 'justify',
                  textJustify: 'inter-word',
                  lineHeight: '1.6'
                }}
              >
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
